import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import ecommerceSaga from "./e-commerce/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import cryptoSaga from "./crypto/saga"
import invoiceSaga from "./invoices/saga"
import jobsSaga from "./jobs/saga"
import projectsSaga from "./projects/saga"
import tasksSaga from "./tasks/saga"
import mailsSaga from "./mails/saga"
import dashboardSaga from "./dashboard/saga"
import dashboardSaasSaga from "./dashboard-saas/saga"
import usersSaga from "./user/saga"
import branchesSaga from "./branch-resource/saga"
import companySaga from "./company-resource/saga"
import customerSaga from "./customer-resource/saga"
import fabricTradingSaga from "./fabric-trading-company-resource/saga"
import fabricSaga from "./fabric-resource/saga"
import fabricSeason from "./season/saga"
import productSaga from "./products/saga"
import specificationSaga from "./specification/saga"
import productCategorySaga from "./product-category/saga"
import rtwProductSaga from "./rtw-product-resource/saga"
import rtwImageSaga from "./rtw-image-resource/saga"
import seasonSaga from "./season-resource/saga"
import dimensionSaga from "./dimension-resource/saga"
import correctionSaga from "./correction-resource/saga"
import infoMeSaga from "./me-resource/saga"
import attendanceSaga from "./attendance-resource/saga"
import staffSaga from "./staff-resource/saga"
import assignmentSaga from "./assignment-resource/saga"
import inspectionSaga from "./inspection-resource/saga"
import productionSummarySaga from "./production-summary/saga"
import fabricOrderSaga from "./fabric-order-resource/saga"
import commonSaga from "./common-resource/saga"
import fabricInventorySaga from "./fabric-inventory-resource/saga"
import rtwInventorySaga from "./rtw-inventory/saga"
import canvasSaga from "./canvas/saga"
import rtwCanvasSaga from "./rtw-canvas/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(invoiceSaga),
    fork(jobsSaga),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(usersSaga),
    fork(branchesSaga),
    fork(companySaga),
    fork(customerSaga),
    fork(fabricTradingSaga),
    fork(fabricSaga),
    fork(fabricSeason),
    fork(productCategorySaga),
    fork(rtwProductSaga),
    fork(rtwImageSaga),
    fork(seasonSaga),
    fork(productSaga),
    fork(specificationSaga),
    fork(dimensionSaga),
    fork(correctionSaga),
    fork(infoMeSaga),
    fork(attendanceSaga),
    fork(staffSaga),
    fork(assignmentSaga),
    fork(inspectionSaga),
    fork(productionSummarySaga),
    fork(fabricOrderSaga),
    fork(commonSaga),
    fork(fabricInventorySaga),
    fork(rtwInventorySaga),
    fork(canvasSaga),
    fork(rtwCanvasSaga),
  ])
}
